export class NotificationModel {
  constructor(
    public id?: string,
    public rId?: string,
    public isRead?: boolean,
    public refNo?: string,
    public criticalityLevel?: string,
    public loadName?: string,
    public parameter?: string,
    public ConditionwithValue?: string,
    public firstStartTime?: string,
    public occurrenceCounter?: string,
    public lastStartTime?: string,
    public lastEndTime?: string
  ) {}

  compare(notification: NotificationModel, attribute: string): number {
    let value = 0;
    switch (attribute) {
      case 'id':
        if (+this.rId > +notification.rId) {
          value = 1;
        }
        if (+this.rId < +notification.rId) {
          value = -1;
        }
        break;
      case 'loadName':
        value = this.loadName.localeCompare(notification.loadName);
        break;
      case 'criticalityLevel':
        value = this.criticalityLevel.localeCompare(
          notification.criticalityLevel
        );
        break;
      case 'parameter':
        value = this.parameter.localeCompare(notification.parameter);
        break;
    }

    return value;
  }
}
